import CSVParametersBuilder from '../CSVParametersBuilder'
import {StaffPerformanceColumnsConfig} from 'constants'
import StaffPerformanceCSVPreviewHeader from './StaffPerformanceCSVPreviewHeader'
import StaffPerformanceCSVPreviewGroupingSection from './StaffPerformanceCSVPreviewGroupingSection'
import StaffPerformanceCSVPreviewLeavesSection from './StaffPerformanceCSVPreviewLeavesSection'
import CSVPreviewEmptySection from '../CSVPreviewEmptySection'
import CSVParametersSection from '../CSVParametersSection'
import StaffPerformanceCSVPreviewOnlyUserColumnsStrategy from './StaffPerformanceCSVPreviewOnlyUserColumnsStrategy'
import StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy from './StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy'
import StaffPerformanceCSVPreviewUsersByGroupsWithSubtotalsColumnsStrategy from './StaffPerformanceCSVPreviewUsersByGroupsWithSubtotalsColumnsStrategy'
import UserGroupMessageProvider from '../../UserGroupMessageProvider'
import TimeZoneGroupMessageProvider from '../../TimeZoneGroupMessageProvider'
import StaffPerformanceCSVPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy from './StaffPerformanceCSVPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy'

export default function StaffPerformanceCSVPreviewGenerator() {}

StaffPerformanceCSVPreviewGenerator.prototype.init = function ()
{
    return this;
};

StaffPerformanceCSVPreviewGenerator.prototype.generatePreviewTable = function ( reportParameters, reportParamsStringBuilder )
{
    var numOfGroupingColumns = ReportPreviewUtils.countNotEmptyLevels( [
                                                                     reportParameters.firstGroupingLevel,
                                                                     reportParameters.secondGroupingLevel,
                                                                     reportParameters.thirdGroupingLevel
                                                                 ] );

    const columnsConfig = reportParameters.columnsConfig
    const groupMessageProvider = this.getGroupMessageProvider(columnsConfig)

    const needSwitchToMe = reportParameters.needSwitchToMe
    const includeOtherUsersColumn = reportParameters.includeOtherUsersColumn

    let columnsStrategy

    switch (columnsConfig) {
        case StaffPerformanceColumnsConfig.USERS_ONLY:
            columnsStrategy = new StaffPerformanceCSVPreviewOnlyUserColumnsStrategy().init(includeOtherUsersColumn, needSwitchToMe)
            break
        case StaffPerformanceColumnsConfig.GROUPS_ONLY:
        case StaffPerformanceColumnsConfig.TZ_GROUPS_ONLY:
            columnsStrategy = new StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy().init(includeOtherUsersColumn, groupMessageProvider)
            break
        case StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITHOUT_SUBTOTALS:
        case StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITHOUT_SUBTOTALS:
            columnsStrategy = new StaffPerformanceCSVPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy().init(includeOtherUsersColumn, groupMessageProvider)
            break
        case StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITH_SUBTOTALS:
        case StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITH_SUBTOTALS:
            columnsStrategy = new StaffPerformanceCSVPreviewUsersByGroupsWithSubtotalsColumnsStrategy().init(includeOtherUsersColumn, groupMessageProvider)
            break
    }

    let numOfDataColumns = columnsStrategy.getNumOfDataColumns()

    var header = new StaffPerformanceCSVPreviewHeader().init(
            reportParameters.firstGroupingLevel,
            reportParameters.secondGroupingLevel,
            reportParameters.thirdGroupingLevel,
            columnsStrategy,
            columnsConfig,
            numOfGroupingColumns,
            groupMessageProvider
    );

    var dataGroupingSection = new StaffPerformanceCSVPreviewGroupingSection().init(
            reportParameters.firstGroupingLevel,
            reportParameters.secondGroupingLevel,
            reportParameters.thirdGroupingLevel,
            columnsStrategy,
            header.hasGroupingRow() ? 2 : 3
    );


    var table = document.createElement( "table" );
    table.className = "reportCsvPreviewTable staffPerfomance";
    var tBody = document.createElement( "tbody" );
    table.appendChild( tBody );

    var totalColumnsNum = numOfGroupingColumns + numOfDataColumns;
    ReportPreviewUtils.addSheetHeaderRow( tBody, totalColumnsNum );

    var paramsBuilder = new CSVParametersBuilder().init();
    paramsBuilder.addDateRangeParam( reportParameters.dateRangeSelection, reportParamsStringBuilder );
    paramsBuilder.addCPParam( reportParameters.customersProjectsSelection, reportParamsStringBuilder );
    paramsBuilder.addUsersParam( reportParameters.userSelection, reportParamsStringBuilder );
    if ( EnabledFeatures.TTA )
        paramsBuilder.addTimeTrackStatusParam( reportParameters.timeApprovalStatus );

    var parametersSection = new CSVParametersSection().init( paramsBuilder, totalColumnsNum );

    parametersSection.addRows( tBody );
    header.addRows( tBody );
    dataGroupingSection.addRows( tBody );

    if( reportParameters.showLeaveTime )
        new StaffPerformanceCSVPreviewLeavesSection().init( columnsStrategy, numOfGroupingColumns ).addRows( tBody );
    else
        new CSVPreviewEmptySection().init( 5, totalColumnsNum ).addRows( tBody );

    return table;
};

StaffPerformanceCSVPreviewGenerator.prototype.getGroupMessageProvider = function(columnConfig){
    switch (columnConfig){
        case StaffPerformanceColumnsConfig.GROUPS_ONLY:
        case StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITH_SUBTOTALS:
        case StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITHOUT_SUBTOTALS:
            return new UserGroupMessageProvider();
        case StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITHOUT_SUBTOTALS:
        case StaffPerformanceColumnsConfig.TZ_GROUPS_ONLY:
        case StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITH_SUBTOTALS:
            return new TimeZoneGroupMessageProvider();
    }
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/staffperformance/StaffPerformanceCSVPreviewGenerator.js